import React from "react";
import { useLocation } from "react-router-dom";
import Navbarlanding from "../../components/Navbarlanding";
import Footerlanding from "../../components/Footerlanding";

const noNavbarFooterPaths = [
  "/login",
  "/builder/signup",
  "/customer/signup",
  "/forgot-password",
  "/reset-password",
  "/customer/profile",
  "/builder/dashboard",
  "/builder/liveproject",
  "/builder/projectinvite",
  "/builder/projectservices",
  "/builder/portfolio",
  "/builder/pendingproject",
  "/builder/holdproject",
  "/builder/rejectionproject",
  "/builder/completionrequest",
  "/builder/completedproject",
  "/builder/notification",
  "/builder/projectenquiry",
  "/builder/chat",
  "/builder/payment",
  "/builder/subscriptionhistory",
  "/builder/subscription",
  "/builder/profile",
  "/builder/support",
  "/builder/profilecard",
  "/customer/projectinvite",
  "/customer/livecard",
  "/customer/holdcard",
  "/customer/requestcard",
  "/customer/completedcard",
  "/customer/rejectcard",
  "/customer/chatbox",
  "/customer/paymenthistory",
  "/customer/help",
  "/customer/notify",
  "/",
  "/master-data/:projectId",
  "/refundpolicy"
];

const AppLayout = ({ children }) => {
  const location = useLocation();
  const showNavbarFooter =
    !noNavbarFooterPaths.some(
      (path) =>
        location.pathname === path ||
        (path.includes(":") && location.pathname.startsWith(path.split(":")[0]))
    ) &&
    !location.pathname.startsWith("/upload-doc/") &&
    !location.pathname.startsWith("/reset-password");

  return (
    <div>
      {showNavbarFooter && <Navbarlanding />}
      {children}
      {showNavbarFooter && <Footerlanding />}
    </div>
  );
};

export default AppLayout;
